import { useEffect, useRef, useState, useTransition } from 'react';

import { fetchPinCodes } from '~modules/pin-code/api';
import { PinCodeDto } from '~modules/pin-code/model';

export function usePinCodes() {
	const [pinCodes, setPinCodes] = useState<PinCodeDto | null>(null);
	const [isError, setIsError] = useState(false);
	const [pending, startLoading] = useTransition();
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			startLoading(async () => {
				try {
					setPinCodes(await fetchPinCodes());
				} catch {
					setIsError(true);
				}
			});
		}
	}, []);

	return { pending, pinCodes, isError };
}
